export const productsReducer = (
  state = {
    camera: [],
    accessories: [],
    projector: [],
    dashcamera: [],
    dashaccessories: [],
    projectaccessories: [],
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "PRODUCTS_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "PRODUCTS_SUCCESS":
      return {
        ...state,
        loading: false,
        [action.payload.type]: action.payload.result,
      };

    case "PRODUCTS_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};


  export const productDetailsReducer = (state = { content: [], loading: true, dataLoaded: false }, action) => {
    switch (action.type) {
      case 'PRODUCTS_DETAILS_REQUEST':
        return { ...state, loading: true };
      case 'PRODUCTS_DETAILS_SUCCESS':
        return { 
          ...state, 
          loading: false, 
          content: action.payload,
          dataLoaded: true
        };
      case 'PRODUCTS_DETAILS_FAIL':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  